export class Exam {
  code: string;
  id: number;
  name: string;
  nk: string;
  exam_type_code: string;
  created_ts: string;
  score: number;

  constructor(exam: Partial<Exam>) {
    _.merge(this, exam);
  }

  static build(exam: Exam): Exam {
    return new Exam(exam);
  }
}

angular.module('capability-ng-transfer')
  .factory('ngExamBuilder', function (): typeof Exam {
    return Exam;
  });



// WEBPACK FOOTER //
// ./app/lib/transfer/builders/exam_builder.ts